import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBannerVariableHeight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 26.354 40.667",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Variabel_h\\xF8yde_Banner",
		"data-name": "Variabel h\\xF8yde_Banner",
		transform: "translate(-115.391 -3365.445)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_2932",
			"data-name": "Group 2932",
			transform: "translate(-1109.85 1724.525)",
			children: [/* @__PURE__ */ _jsx("g", {
				id: "Page-1",
				transform: "translate(1227.944 1672.579)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "layout-card--auto",
					transform: "translate(0 0)",
					children: /* @__PURE__ */ _jsx("g", {
						id: "layout--img-top",
						transform: "translate(0)",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "Group",
							children: [/* @__PURE__ */ _jsx("path", {
								id: "Shape",
								d: "M4.5,17.5v2.252H30.736V17.5Z",
								transform: "translate(-7.204 -10.744)",
								fillRule: "evenodd"
							}), /* @__PURE__ */ _jsx("path", {
								id: "Shape-2",
								"data-name": "Shape",
								d: "M4.5,14.5v2.252H30.736V14.5Z",
								transform: "translate(-7.204 -14.5)",
								fillRule: "evenodd"
							})]
						})
					})
				})
			}), /* @__PURE__ */ _jsx("path", {
				id: "image_FILL1_wght400_GRAD0_opsz48",
				d: "M122.2,242.354a2.252,2.252,0,0,1-2.2-2.2V218.2a2.252,2.252,0,0,1,2.2-2.2h21.962a2.252,2.252,0,0,1,2.2,2.2v21.962a2.252,2.252,0,0,1-2.2,2.2Zm2.05-5.747h17.9l-5.381-7.174-4.832,6.259-3.4-4.649Z",
				transform: "translate(1105.24 1424.92)"
			})]
		})
	})
});
export default SvgBannerVariableHeight;
